class ProductCardCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    if (!this.els['navigation.prev'] || !this.els['navigation.next']) {
      return
    }

    this.scrollMedia = this.scrollMedia.bind(this)
    this.els['navigation.prev'].element.addEventListener('click', () =>
      this.scrollMedia(-1),
    )
    this.els['navigation.next'].element.addEventListener('click', () =>
      this.scrollMedia(1),
    )
  }

  scrollMedia (direction) {
    const itemWidth = this.firstElementChild.clientWidth
    const maxScrollLeft = this.scrollWidth - this.clientWidth

    if (
      (direction === 1 && this.scrollLeft >= maxScrollLeft) ||
      (direction === -1 && this.scrollLeft <= 0)
    ) {
      return
    }

    this.scrollBy({
      left: direction * itemWidth,
      behavior: 'smooth',
    })
  }
}

if (!customElements.get('product-card-carousel')) {
  customElements.define('product-card-carousel', ProductCardCarousel)
}
